(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["weftide-product-experience"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wft-gallery-choices')) {
    customElements.define('wft-gallery-choices', class extends HTMLElement {
      connectedCallback() {
        this.gallery = document.getElementById(this.dataset.gallery);
        if (!this.gallery) return;
        this.onClick = (event) => {
          const button = event.target.closest('button[data-media]');
          if (!button || typeof this.gallery.setActiveMedia !== 'function') return;
          this.gallery.setActiveMedia(button.dataset.media, false);
          this.select(button.dataset.media);
        };
        this.onSlide = (event) => this.select(event.detail.currentElement.dataset.mediaId);
        this.addEventListener('click', this.onClick);
        this.gallery.addEventListener('slideChanged', this.onSlide);
        this.observer = new MutationObserver(() => {
          const current = this.gallery.querySelector('.thumbnail[aria-current="true"]');
          const target = current?.closest('[data-target]')?.dataset.target;
          if (target) this.select(target);
        });
        this.observer.observe(this.gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
        customElements.whenDefined('media-gallery').then(() => {
          if (this.isConnected) this.hidden = false;
        });
      }
      select(mediaId) {
        this.querySelectorAll('button[data-media]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.media === mediaId));
        });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.gallery?.removeEventListener('slideChanged', this.onSlide);
        this.observer?.disconnect();
      }
    });
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-wft-open-size-guide]');
    if (!link) return;
    const guide = document.getElementById(link.hash.slice(1));
    if (!guide) return;
    guide.open = true;
    guide.querySelector('summary')?.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["weftide-waitlist"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('weftide-waitlist'))customElements.define('weftide-waitlist',class extends HTMLElement{
 connectedCallback(){
  this.form=this.querySelector('form');this.size=this.querySelector('[data-waitlist-size]');this.tags=this.querySelector('[data-waitlist-tags]');
  const update=()=>{if(this.size)this.tags.value=['newsletter','weftide-waitlist','weftide-consent-launch-availability-v1','piece-'+this.dataset.piece,'garment-'+this.dataset.product,'size-'+this.size.value,'interest-'+this.dataset.product+'--'+this.size.selectedOptions[0].dataset.variant].join(',')};
  this.size?.addEventListener('change',update);this.form.addEventListener('submit',update);
  this.onVariant=()=>{const id=document.querySelector('#product-form-'+this.dataset.section+' [name=id]')?.value;const option=Array.from(this.size?.options||[]).find(o=>o.dataset.variant===id);if(option){this.size.value=option.value;update()}};
  this.info=document.getElementById('ProductInfo-'+this.dataset.section);this.onChange=(event)=>{if(event.target.matches('.product-variant-id'))this.onVariant()};this.info?.addEventListener('change',this.onChange);
  const sticky=this.querySelector('.wft-waitlist-sticky');const gallery=document.getElementById('MediaGallery-'+this.dataset.section);
  if(sticky&&gallery){let below=false,formVisible=true;const draw=()=>{sticky.hidden=!below||formVisible};this.galleryObserver=new IntersectionObserver(entries=>{below=entries[0].boundingClientRect.bottom<0;draw()});this.galleryObserver.observe(gallery);this.formObserver=new IntersectionObserver(entries=>{formVisible=entries[0].isIntersecting;draw()});this.formObserver.observe(this.form);sticky.querySelector('a').addEventListener('click',()=>{this.form.querySelector('input[type=email]').focus({preventScroll:true})})}
 }
 disconnectedCallback(){this.info?.removeEventListener('change',this.onChange);this.galleryObserver?.disconnect();this.formObserver?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
